import { Card } from "@mui/material";

export default function CardLastUpdated({fund}){
return (<Card sx={{ backgroundColor: 'white', color: 'black', padding:'8px 8px' }}>
    <span>{'Figures As of '+new Date(fund.lastUpdated).toDateString()}</span>
</Card>)
}